export const API_URL = process.env.REACT_APP_API_BASE_URL as string;
export const JWT_SECRET = '123456' as string;
